import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=477bf48a&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=477bf48a&scoped=true&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=477bf48a&lang=css&"
import style2 from "./Show.vue?vue&type=style&index=2&id=477bf48a&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477bf48a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477bf48a')) {
      api.createRecord('477bf48a', component.options)
    } else {
      api.reload('477bf48a', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=477bf48a&scoped=true&", function () {
      api.rerender('477bf48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/Show.vue"
export default component.exports